"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _systemSetting = require("@/api/systemSetting.js");
var _activityListApi = require("@/api/activityListApi.js");
var _EditMarket = _interopRequireDefault(require("./EditMarket.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    EditMarket: _EditMarket.default
  },
  props: {
    pageType: {
      type: Number,
      default: 0
    },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      activeSetting: 1,
      itemInfo: {},
      userType: null,
      activityTypeChecking: false,
      goodsShowTypeOptions: [{
        label: '一行两图',
        value: 2
      }, {
        label: '一行三图',
        value: 3
      }, {
        label: '一行四图',
        value: 4
      }, {
        label: '田字格',
        value: 5
      }, {
        label: '两行六图',
        value: 7
      }, {
        label: '两行八图',
        value: 6
      }],
      cardDisplayOptions: [{
        label: '售价',
        value: 1
      }, {
        label: '购物车',
        value: 2
      }, {
        label: '商品名称',
        value: 3
      }, {
        label: '原价',
        value: 4
      }, {
        label: '新人价',
        value: 5
      }]
    };
  },
  computed: {
    availableGoodsShowTypes: function availableGoodsShowTypes() {
      // 手动左右滑动：仅一行两/三/四图；上下自动滚动：全部
      if (Number(this.itemInfo.interactionType) === 1) {
        return this.goodsShowTypeOptions.filter(function (item) {
          return [2, 3, 4].includes(item.value);
        });
      }
      return this.goodsShowTypeOptions;
    },
    // 新人专享不展示原价；其他类型不展示新人价
    availableCardDisplayOptions: function availableCardDisplayOptions() {
      var activityType = Number(this.itemInfo.activityType);
      return this.cardDisplayOptions.filter(function (item) {
        if (activityType === 1 && item.value === 4) return false;
        if (activityType === 2 && item.value === 5) return false;
        return true;
      });
    }
  },
  watch: {
    value: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.itemInfo = _objectSpread(_objectSpread({
          showType: 19,
          activityType: 1,
          bgImg: '',
          bgUrl: '',
          goodsInfo: {},
          roderSort: 1,
          goodsTagImg: '',
          interactionType: 2,
          goodsShowType: 2,
          goodsUrl: '',
          cardDisplayTypes: [],
          cardDisplayType: 1,
          bgCornerType: 1,
          // 1批量 2单独
          goodsCornerType: 1,
          bgLayout: {
            ml: 0,
            mr: 0,
            mt: 0,
            mb: 0,
            tl: 0,
            tr: 0,
            bl: 0,
            br: 0
          },
          goodsLayout: {
            ml: 0,
            mr: 0,
            mt: 0,
            mb: 0,
            tl: 0,
            tr: 0,
            bl: 0,
            br: 0
          },
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 0,
            mr: 0
          }
        }, val), {}, _defineProperty(_defineProperty({}, "bgLayout", _objectSpread({
          ml: 0,
          mr: 0,
          mt: 0,
          mb: 0,
          tl: 0,
          tr: 0,
          bl: 0,
          br: 0
        }, val.bgLayout || {})), "goodsLayout", _objectSpread({
          ml: 0,
          mr: 0,
          mt: 0,
          mb: 0,
          tl: 0,
          tr: 0,
          bl: 0,
          br: 0
        }, val.goodsLayout || {})));
        // 未配置时按活动类型给默认勾选，已配置时只过滤当前类型不可用项。
        this.ensureValidCardDisplayTypes(false);
        // 保留旧字段，避免依赖老字段的预览/后端逻辑受影响
        this.$set(this.itemInfo, 'cardDisplayType', this.itemInfo.cardDisplayTypes[0] || 1);
        this.ensureValidGoodsShowType();
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
  },
  methods: {
    ensureValidGoodsShowType: function ensureValidGoodsShowType() {
      // 交互样式=手动左右滑动时，仅支持一行两/三/四图
      if (Number(this.itemInfo.interactionType) === 1 && ![2, 3, 4].includes(Number(this.itemInfo.goodsShowType))) {
        this.$set(this.itemInfo, 'goodsShowType', 2);
      }
      // 已取消一行一图，旧数据若仍为1则回退到一行两图
      if (Number(this.itemInfo.goodsShowType) === 1) {
        this.$set(this.itemInfo, 'goodsShowType', 2);
      }
    },
    ensureValidCardDisplayTypes: function ensureValidCardDisplayTypes() {
      var shouldEmit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var availableValues = this.availableCardDisplayOptions.map(function (item) {
        return item.value;
      });
      var current = Array.isArray(this.itemInfo.cardDisplayTypes) ? this.itemInfo.cardDisplayTypes : [];
      var selected = current.filter(function (value) {
        return availableValues.includes(Number(value));
      });
      var nextSelected = selected.length && selected.length <= 3 ? selected : this.getDefaultCardDisplayTypes();
      this.$set(this.itemInfo, 'cardDisplayTypes', nextSelected);
      this.$set(this.itemInfo, 'cardDisplayType', nextSelected[0] || 1);
      if (shouldEmit) this.updateItem();
    },
    getDefaultCardDisplayTypes: function getDefaultCardDisplayTypes() {
      return Number(this.itemInfo.activityType) === 1 ? [2, 3, 5] : [1, 3, 2];
    },
    handleCardDisplayTypesChange: function handleCardDisplayTypesChange() {
      this.ensureValidCardDisplayTypes(true);
    },
    getGoodsSkuIds: function getGoodsSkuIds() {
      var goodsInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var raw = goodsInfo.skuId || goodsInfo.goodsStr || '';
      var values = Array.isArray(raw) ? raw : String(raw).split(',');
      return _toConsumableArray(new Set(values.map(function (item) {
        return Number(String(item).trim());
      }).filter(function (item) {
        return Number.isInteger(item) && item > 0;
      })));
    },
    checkGoodsNewcomerPrice: function () {
      var _checkGoodsNewcomerPrice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var goodsInfo,
          skuIds,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              goodsInfo = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              skuIds = this.getGoodsSkuIds(goodsInfo);
              if (skuIds.length) {
                _context.n = 1;
                break;
              }
              return _context.a(2, {
                configuredSkuIds: [],
                unconfiguredSkuIds: []
              });
            case 1:
              return _context.a(2, (0, _activityListApi.checkActivityNewcomerPriceApi)({
                skuIds: skuIds.join(','),
                designId: this.$route.query.id || undefined,
                miniAppId: this.$route.query.miniAppId || undefined
              }));
          }
        }, _callee, this);
      }));
      function checkGoodsNewcomerPrice() {
        return _checkGoodsNewcomerPrice.apply(this, arguments);
      }
      return checkGoodsNewcomerPrice;
    }(),
    validateGoodsForActivity: function () {
      var _validateGoodsForActivity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(goodsInfo, activityType) {
        var skuIds, result, configuredSkuIds, unconfiguredSkuIds, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              skuIds = this.getGoodsSkuIds(goodsInfo);
              if (skuIds.length) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, true);
            case 1:
              _context2.n = 2;
              return this.checkGoodsNewcomerPrice(goodsInfo);
            case 2:
              result = _context2.v;
              configuredSkuIds = result.configuredSkuIds || [];
              unconfiguredSkuIds = result.unconfiguredSkuIds || [];
              if (!(Number(activityType) === 1 && unconfiguredSkuIds.length)) {
                _context2.n = 3;
                break;
              }
              this.$message.error("".concat(unconfiguredSkuIds.join('、'), " \u5C1A\u672A\u914D\u7F6E\u65B0\u4EBA\u4EF7\uFF0C\u8BF7\u5148\u5B8C\u6210\u65B0\u4EBA\u4EF7\u8BBE\u7F6E\u540E\u518D\u9009\u62E9\u8BE5\u6D3B\u52A8"));
              return _context2.a(2, false);
            case 3:
              if (!(Number(activityType) === 2 && configuredSkuIds.length)) {
                _context2.n = 7;
                break;
              }
              _context2.p = 4;
              _context2.n = 5;
              return this.$confirm("\u5546\u54C1SKU ".concat(configuredSkuIds.join('、'), " \u5F53\u524D\u5DF2\u914D\u7F6E\u65B0\u4EBA\u4EF7\uFF0C\u5EFA\u8BAE\u4E0D\u540C\u65F6\u53C2\u4E0E\u5176\u4ED6\u6D3B\u52A8\uFF0C\u5426\u5219\u7528\u6237\u5728\u5176\u4ED6\u6D3B\u52A8\u4E2D\u4E0B\u5355\u5C06\u5C55\u793A\u65B0\u4EBA\u4EF7\uFF0C\u5F71\u54CD\u7528\u6237\u4F53\u9A8C\uFF5E"), '提示', {
                confirmButtonText: '继续选择',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 5:
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t = _context2.v;
              return _context2.a(2, false);
            case 7:
              return _context2.a(2, true);
          }
        }, _callee2, this, [[4, 6]]);
      }));
      function validateGoodsForActivity(_x, _x2) {
        return _validateGoodsForActivity.apply(this, arguments);
      }
      return validateGoodsForActivity;
    }(),
    handleActivityTypeChange: function () {
      var _handleActivityTypeChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(activityType) {
        var nextActivityType, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              nextActivityType = Number(activityType);
              if (!(this.activityTypeChecking || nextActivityType === Number(this.itemInfo.activityType))) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.activityTypeChecking = true;
              _context3.p = 2;
              _context3.n = 3;
              return this.validateGoodsForActivity(this.itemInfo.goodsInfo || {}, nextActivityType);
            case 3:
              if (_context3.v) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2);
            case 4:
              this.$set(this.itemInfo, 'activityType', nextActivityType);
              if (this.itemInfo.goodsInfo) {
                this.$set(this.itemInfo.goodsInfo, 'isCheap', nextActivityType === 1 ? 1 : 0);
              }
              this.$set(this.itemInfo, 'cardDisplayTypes', this.getDefaultCardDisplayTypes());
              this.ensureValidCardDisplayTypes(true);
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t2 = _context3.v;
            case 6:
              _context3.p = 6;
              this.activityTypeChecking = false;
              return _context3.f(6);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 5, 6, 7]]);
      }));
      function handleActivityTypeChange(_x3) {
        return _handleActivityTypeChange.apply(this, arguments);
      }
      return handleActivityTypeChange;
    }(),
    handleInteractionChange: function handleInteractionChange() {
      this.ensureValidGoodsShowType();
      this.updateItem();
    },
    handleVerticalMarginChange: function handleVerticalMarginChange(layoutKey, field) {
      var layout = this.itemInfo[layoutKey] || {};
      if (field === 'mt' && Number(layout.mt) !== 0) this.$set(layout, 'mb', 0);
      if (field === 'mb' && Number(layout.mb) !== 0) this.$set(layout, 'mt', 0);
      this.updateItem();
    },
    getBatchRadius: function getBatchRadius(layoutKey) {
      return Number((this.itemInfo[layoutKey] || {}).tl) || 0;
    },
    setBatchRadius: function setBatchRadius(layoutKey, val) {
      var num = Math.min(100, Math.max(0, Number(val) || 0));
      var layout = this.itemInfo[layoutKey] || {};
      this.$set(layout, 'tl', num);
      this.$set(layout, 'tr', num);
      this.$set(layout, 'bl', num);
      this.$set(layout, 'br', num);
      this.updateItem();
    },
    syncBatchRadius: function syncBatchRadius(layoutKey) {
      this.setBatchRadius(layoutKey, (this.itemInfo[layoutKey] || {}).tl);
    },
    toggleCornerType: function toggleCornerType(typeKey, layoutKey) {
      var next = Number(this.itemInfo[typeKey]) === 2 ? 1 : 2;
      this.$set(this.itemInfo, typeKey, next);
      // 切回批量时，用左上角值统一四角
      if (next === 1) {
        this.setBatchRadius(layoutKey, this.getBatchRadius(layoutKey));
      } else {
        this.updateItem();
      }
    },
    updateItem: function updateItem() {
      this.$emit('input', this.itemInfo);
    },
    settingGoods: function settingGoods() {
      var _this$$refs$EditMarke;
      (_this$$refs$EditMarke = this.$refs.EditMarketRef) === null || _this$$refs$EditMarke === void 0 ? void 0 : _this$$refs$EditMarke.openInit(0, this.itemInfo.goodsInfo || {});
    },
    saveGoods: function () {
      var _saveGoods = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(index, item) {
        var goodsInfo, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return this.validateGoodsForActivity(item || {}, Number(this.itemInfo.activityType));
            case 1:
              if (_context4.v) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              goodsInfo = _objectSpread(_objectSpread({}, item || {}), {}, {
                isCheap: Number(this.itemInfo.activityType) === 1 ? 1 : 0
              });
              this.$set(this.itemInfo, 'goodsInfo', goodsInfo);
              this.updateItem();
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 3]]);
      }));
      function saveGoods(_x4, _x5) {
        return _saveGoods.apply(this, arguments);
      }
      return saveGoods;
    }(),
    modalPicTap: function modalPicTap(tit, type) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.$set(_this.itemInfo, type, img[0].sattDir);
        _this.updateItem();
      }, tit, 'system');
    },
    removeImg: function removeImg(type) {
      this.$set(this.itemInfo, type, '');
      this.updateItem();
    },
    beforeUpload: function beforeUpload(file, maxKb) {
      var allowTypes = ['image/jpeg', 'image/png'];
      var name = (file.name || '').toLowerCase();
      var isExtOk = /\.(jpe?g|png)$/.test(name);
      var isTypeOk = allowTypes.includes(file.type) || isExtOk;
      var isLt = file.size / 1024 <= maxKb;
      if (!isTypeOk) {
        this.$message.error('只能上传jpg、png、jpeg格式图片！');
        return false;
      }
      if (!isLt) {
        this.$message.error("\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ".concat(maxKb, "KB"));
        return false;
      }
      return true;
    },
    handleLocalUpload: function () {
      var _handleLocalUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(options, fieldName) {
        var file, formData, params, loading, res, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              file = options.file;
              formData = new FormData();
              formData.append('multipart', file);
              params = {
                model: 'product',
                pid: 1
              };
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context5.p = 1;
              _context5.n = 2;
              return (0, _systemSetting.fileImageApi)(formData, params);
            case 2:
              res = _context5.v;
              loading.close();
              if (res && res.url) {
                this.$set(this.itemInfo, fieldName, res.url);
                this.updateItem();
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t4 = _context5.v;
              loading.close();
              this.$message.error('上传失败：' + (_t4.message || '请重试'));
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function handleLocalUpload(_x6, _x7) {
        return _handleLocalUpload.apply(this, arguments);
      }
      return handleLocalUpload;
    }()
  }
};